<ui-dropdown
    #menu
    type="menu"
    (open)="open()">
    <ui-dropdown-item
        id="interaction-create-new-campaign-button"
        class="menu-option"
        (click)="redirectToCreateCampaign()"
        [disabled]="!hasActiveDesigns"
        svgIcon="display-campaign">
        {{ hasConnectedCampaigns ? 'Create new display campaign' : 'Display campaign' }}
    </ui-dropdown-item>
    <ng-container *permissions="'SocialCampaignManager'">
        <div
            class="social-campaign"
            uiTooltip="You do not have any social sizes in this creative set"
            [uiTooltipDisabled]="isSocialCamapaignAvailable">
            <ui-dropdown-item
                id="create-new-social-campaign"
                class="menu-option"
                [disabled]="!isSocialCamapaignAvailable"
                svgIcon="social-campaign"
                (click)="redirectToCreateSocialCampaign()">
                {{ hasConnectedCampaigns ? 'Create new social campaign ' : 'Social campaign' }}
            </ui-dropdown-item>
            <a
                *ngIf="!isSocialCamapaignAvailable"
                class="link"
                rel="noopener"
                target="_blank"
                href="https://support.bannerflow.com/en/articles/6499649"
                >Read more</a
            >
        </div>
    </ng-container>
    <ui-dropdown-divider *ngIf="hasConnectedCampaigns || isAddToCampaignVisible"></ui-dropdown-divider>
    <ui-dropdown-item
        svgIcon="display-campaign"
        *ngFor="let campaign of campaigns || []"
        [uiTooltip]="campaign.name"
        [uiTooltipDisabled]="!campaign.name || campaign.name.length < 25"
        (click)="openCampaign(campaign.id)">
        {{ campaign.name | dotdotdot: 25 }}
    </ui-dropdown-item>
    <ui-dropdown-divider *ngIf="hasConnectedCampaigns || isAddToCampaignVisible"></ui-dropdown-divider>
    <ui-dropdown-item
        *ngIf="isAddToCampaignVisible"
        id="add-to-campaign-context-menu"
        class="custom-dropdown"
        [uiDropdownTarget]="addToCampaignDropdown.dropdown"
        [disabled]="addToCampaignDisabled">
        <div class="custom-item">
            <div class="custom-text">{{ addToCampaignText }}</div>
        </div>
    </ui-dropdown-item>

    <add-to-campaign-dropdown
        #addToCampaignDropdown
        (disabled)="addToCampaignDisabled = $event"
        (title)="addToCampaignText = $event"></add-to-campaign-dropdown>
</ui-dropdown>
